/** 内部运维登录路径（不挂在对外首页，仅适用于知晓地址的授权人员） */
export const STAFF_CONSOLE_LOGIN_PATH = '/staff/signin';

/** 超级管理员在平台控制台内的默认落地页（租户侧 Shell 也会将超管重定向至此） */
export const PLATFORM_ADMIN_HOME = '/platform-admin/teams';

/**
 * 登录成功后的跳转路径：超管不进租户工作台，仅当回跳目标是 /platform-admin/* 时保留。
 */
export function resolvePostLoginPath(opts: {
  role: string | null | undefined;
  /** 登录前想去的页面（如 AuthGuard 记录的 from） */
  from?: { pathname?: string; search?: string } | null;
  /** 非超管、且无 from 时的默认路径 */
  tenantDefault?: string;
}): string {
  const tenantFallback = opts.tenantDefault ?? '/dashboard';
  if (opts.role === '超级管理员') {
    const p = opts.from?.pathname || '';
    if (p.startsWith('/platform-admin')) {
      return `${p}${opts.from?.search || ''}`;
    }
    return PLATFORM_ADMIN_HOME;
  }
  if (opts.from?.pathname) {
    return `${opts.from.pathname}${opts.from.search || ''}`;
  }
  return tenantFallback;
}
